import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  data: Date;
}

@Component({
  selector: 'app-select-time-dialog',
  templateUrl: './select-time-dialog.component.html',
  styleUrls: ['./select-time-dialog.component.css']
})
export class SelectTimeDialogComponent implements OnInit {
  dateDiff = '0';
  timeData = new Date();

  constructor(
    public auth: AuthService,
    private dialogRef: MatDialogRef<SelectTimeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public keySet: DialogData) {
      this.timeData = this.keySet.data;
      dialogRef.disableClose = true;
    }

  ngOnInit(): void {
    console.log('init', this.timeData);
  }

  dateDiffChange(diff: string) {
    const newDate = new Date(this.timeData);

    if (diff !== '0') {
      newDate.setDate(this.keySet.data.getDate() + Number(diff));
      this.timeData = newDate;
    }
  }

  timeChange(time: string) {
    const newDate = new Date(this.timeData);

    const buf = time.split(':');
    if (buf.length === 2) {
      newDate.setHours(parseInt(buf[0], 10), parseInt(buf[1], 10));
      this.timeData = newDate;
    }
  }

  onSubmit() {
    //this.keySet.data.setDate(this.timeData.getDate());
    console.log('submit time :', this.keySet.data);
    this.dialogRef.close(this.timeData);
  }

  onCancel() {
    // return undefined
    this.dialogRef.close();
  }

}
